export const INTEGRATION_RETURN_PATH_KEY =
  'integrationReturnPathAfterConnection';

const LEAD_TYPE_ALIASES = {
  'github-enterprise': 'github_enterprise',
  'self-hosted-gitlab': 'gitlab_enterprise',
  gitlabee: 'gitlab_enterprise',
  gitlabEE: 'gitlab_enterprise',
  'self-hosted-bitbucket': 'bitbucket_server'
};

const INTEGRATION_TYPE_LABELS = {
  github: 'GitHub',
  gitlab: 'GitLab',
  bitbucket: 'Bitbucket',
  github_enterprise: 'GitHub Enterprise',
  gitlab_enterprise: 'Self-Hosted GitLab',
  bitbucket_server: 'Self-Hosted Bitbucket'
};

export const normalizeIntegrationType = type => {
  const normalizedType = String(type || '').trim();
  if (!normalizedType) {
    return '';
  }

  return (
    LEAD_TYPE_ALIASES[normalizedType] ||
    LEAD_TYPE_ALIASES[normalizedType.toLowerCase()] ||
    normalizedType.toLowerCase()
  );
};

export const formatIntegrationType = type => {
  const normalizedType = normalizeIntegrationType(type);

  if (!normalizedType) {
    return 'Git Provider';
  }

  if (INTEGRATION_TYPE_LABELS[normalizedType]) {
    return INTEGRATION_TYPE_LABELS[normalizedType];
  }

  return normalizedType
    .replace(/[_-]+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const getUserLeadTypeValues = user => {
  if (Array.isArray(user?.leadConnections) && user.leadConnections.length > 0) {
    return user.leadConnections.map(connection => connection?.type);
  }

  if (Array.isArray(user?.leadType)) {
    return user.leadType;
  }

  return String(user?.leadType || '').split(',');
};

export const getNormalizedLeadTypesFromUser = user =>
  getUserLeadTypeValues(user).map(normalizeIntegrationType).filter(Boolean);

export const getLeadConnectionsFromUser = user => {
  if (Array.isArray(user?.leadConnections) && user.leadConnections.length > 0) {
    return user.leadConnections
      .map(connection => {
        const type = normalizeIntegrationType(connection?.type);

        return {
          ...connection,
          type,
          label: connection?.label || formatIntegrationType(type)
        };
      })
      .filter(connection => connection.type || connection.label);
  }

  return [...new Set(getNormalizedLeadTypesFromUser(user))].map(type => ({
    id: type,
    type,
    label: formatIntegrationType(type)
  }));
};

export const hasLeadConnections = user =>
  getLeadConnectionsFromUser(user).length > 0;

export const setPostIntegrationReturnPath = () => {
  localStorage.setItem(
    INTEGRATION_RETURN_PATH_KEY,
    '/settings/integrations?integration=connected'
  );
};
